"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var SignUpThankYou_1 = require("./steps/SignUpThankYou");
var CloseBtn_1 = require("../common/Btn/CloseBtn");
var signup_modal_1 = require("./utils/signup-modal");
var SignupContext_1 = require("./SignupContext");
var SignUpStep1_1 = require("./steps/SignUpStep1");
var SignUpStep2_1 = require("./steps/SignUpStep2");
var SignUpStep3_1 = require("./steps/SignUpStep3");
var SignupModal = function () {
    var _a = (0, hooks_1.useState)(''), email = _a[0], setEmail = _a[1];
    var _b = (0, hooks_1.useState)(''), phone = _b[0], setPhone = _b[1];
    var _c = (0, hooks_1.useContext)(SignupContext_1.SignupContext), formStep = _c.formStep, setFormStep = _c.setFormStep, setModalOpen = _c.setModalOpen;
    var handleEmailChange = function (event) {
        if (event.target instanceof HTMLInputElement) {
            setEmail(event.target.value);
        }
    };
    var handleAnimationEvent = function () {
        setFormStep(1);
    };
    var handlePhoneChange = function (event) {
        if (event.target instanceof HTMLInputElement) {
            var formattedPhoneNumber = (0, signup_modal_1.formatPhoneNumber)(event.target.value);
            setPhone(formattedPhoneNumber);
        }
    };
    var discountPercent = '25%';
    var discountTermsAgain = '25% OFF';
    var code = 'NEW25';
    var upTo = false;
    (0, hooks_1.useEffect)(function () {
        window.localStorage.setItem('signupModalLastSeen', new Date().toString());
    }, []);
    function renderStepComponents() {
        switch (formStep) {
            case 0:
                return ((0, preact_1.h)(SignUpStep1_1.default, { handleAnimationEvent: handleAnimationEvent, discountPercent: discountPercent }));
            case 1:
                return ((0, preact_1.h)(SignUpStep2_1.default, { email: email, handleEmailChange: handleEmailChange, discountPercent: discountPercent, upTo: upTo }));
            case 2:
                return (0, preact_1.h)(SignUpStep3_1.default, { email: email, phone: phone, handlePhoneChange: handlePhoneChange });
            case 3:
                return (0, preact_1.h)(SignUpThankYou_1.default, { code: code, discountTermsAgain: discountTermsAgain });
            default:
                return null;
        }
    }
    return ((0, preact_1.h)("div", { class: "signup-modal" },
        (0, preact_1.h)("div", { class: "signup-modal__close-btn" },
            (0, preact_1.h)(CloseBtn_1.default, { closeFn: function () {
                    setModalOpen(false);
                } })),
        (0, preact_1.h)("img", { class: "signup-modal__image hide-on-mobile", src: "https://cdn.shopify.com/s/files/1/0588/9340/2261/files/email-pop-up-desktop.jpg?v=1702682863" }),
        (0, preact_1.h)("img", { class: "signup-modal__image hide-on-desktop", src: "https://cdn.shopify.com/s/files/1/0588/9340/2261/files/email-pop-up-mobile.jpg?v=1702674533" }),
        (0, preact_1.h)("div", { class: "signup-modal__info" },
            (0, preact_1.h)("img", { class: "signup-modal__logo signup-modal__logo--step-".concat(formStep), src: "https://cdn.shopify.com/s/files/1/0588/9340/2261/files/OPositivHealthLogo_Black.svg?v=1709579505" }),
            renderStepComponents())));
};
exports.default = SignupModal;
